import React from 'react';
import { Offcanvas, Button, Form, Card, Row, Col, Image, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function OffcanvasUpdateAPI({ show, onHide, selectedRow, onSubmit, isLoadingButton }) {
    const { t } = useTranslation();

    return (
        <Offcanvas show={show} onHide={onHide} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title><h2>{t('Edit REST-API Credential')}</h2></Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                {/* Form */}
                <Form onSubmit={onSubmit}>
                    <Card className="mb-4">
                        <Card.Header className="card-header-height d-flex justify-content-between align-items-center">
                            <h4 className="mb-0">{t('REST-API Credential')}</h4>
                        </Card.Header>
                        <Card.Body className="">
                            <Row className="mb-2 d-none">
                                <Col lg={12} md={12} className="mb-0">
                                    {/* API ID */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="id">{t('ID')}</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id="id"
                                            defaultValue={selectedRow ? selectedRow.id : ''}
                                            readOnly
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-2">
                                <Col lg={12} md={12} className="mb-0">
                                    {/* API Description */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="api_description">{t('Application Name')}</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id="api_description"
                                            placeholder={t('Enter Application name')}
                                            defaultValue={selectedRow ? selectedRow.api_description : ''}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-2">
                                <Col lg={12} md={12} className="mb-0">
                                    {/* API Client ID */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="api_client_id">{t('API Client ID')}</Form.Label>
                                        <Form.Control
                                            plaintext
                                            id="api_client_id"
                                            defaultValue={selectedRow ? selectedRow.api_client_id : ''}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-2">
                                <Col lg={12} md={12} className="mb-0">
                                    {/* API Client Secret */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="api_client_secret">{t('API Client Secret')}</Form.Label>
                                        <Form.Control
                                            plaintext
                                            id="api_client_secret"
                                            defaultValue="********************"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-0">
                                <Col lg={12} md={12} className="mb-0">
                                    {/* API Timestamp */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="api_timestamp_created">{t('Timestamp created')}</Form.Label>
                                        <Form.Control
                                            plaintext
                                            id="api_timestamp_created"
                                            defaultValue={selectedRow ? selectedRow.api_timestamp_created : ''}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <Card className="mb-4">
                        <Card.Header className="card-header-height d-flex justify-content-between align-items-center">
                            <h4 className="mb-0">{t('Help')}</h4>
                        </Card.Header>
                        <Card.Body className="">
                            <Row className="mb-4">
                                <Col lg={12} md={12} className="mb-0">
                                <p>
                                    {t('To use the API credentials, include the following headers in your API requests:')}
                                </p>
                                <ul>
                                    <li><code>x-api-client-id</code>: {selectedRow ? selectedRow.api_client_id : t('Your API Client ID')}</li>
                                    <li><code>x-api-client-secret</code>: {t('Your API Client Secret')}</li>
                                </ul>
                                <p>
                                    {t('Ensure these headers are included in every request to authenticate and access the API.')}
                                </p>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <div className="d-flex justify-content-end mt-4">
                        <Button variant="secondary" onClick={onHide}>
                            {t('Cancel')}
                        </Button>
                        <Button className="ms-2 d-end" variant="primary" type="submit" disabled={isLoadingButton}>
                            {isLoadingButton ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    {t('Update REST-API Credentials')}
                                </>
                            ) : (
                                t('Update REST-API Credentials')
                            )}
                        </Button>
                    </div>

                </Form>
            </Offcanvas.Body>
        </Offcanvas>
    );
}

export default OffcanvasUpdateAPI;